import React from "react";
import { Tooltip, TooltipProps } from "@mui/material";

const customStyles = `
  :root {
    --color-hp-light-blue: #edf4ff;
    --color-hp-med-blue: #96b3e1;
    --color-hp-dark-blue: #5985cb;
  }
  .MuiTooltip-tooltip {
    background-color: var(--color-hp-light-blue) !important;
    color: var(--color-hp-dark-blue) !important;
    border: 1px solid var(--color-hp-med-blue) !important;
    font-weight: 500;
    font-size: 12px;
  }
  .MuiTooltip-arrow {
    color: var(--color-hp-med-blue) !important;
  }
`;

const HPTooltip: React.FC<TooltipProps> = ({ children, ...props }) => {
  return (
    <>
      <style>{customStyles}</style>
      <Tooltip
        {...props}
        sx={{
          maxWidth: "120px",
        }}
        PopperProps={{
          popperOptions: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -10],
                },
              },
            ],
          },
        }}
      >
        {children}
      </Tooltip>
    </>
  );
};

export default HPTooltip;
